// extracted by mini-css-extract-plugin
module.exports = {"statusDescription":"InfralistPage_statusDescription__3IFZL"};